import { Component, OnInit } from '@angular/core';
import { AgentlocationService } from '../../services/agent_location/agentlocation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { SearchTermservice } from '../../services/search/search-service.service';
@Component({
  selector: 'app-locationsummary',
  templateUrl: './locationsummary.component.html',
  styleUrls: ['./locationsummary.component.css']
})
export class LocationsummaryComponent implements OnInit {
  fencingTypeValidationMsg: string;
  fencingTypeValidation: boolean = true;
  phoneNumberValidationMsg: any;
  phoneNumberValidation: boolean = true;
  agentDetails: any;
  agentlocationDetails: any;
  locationDetails: any;
  public locationResults: any[] = [];
  locationId: any;
  submitSuccess;
  message;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  private agentId: any;
  public fenceflag: boolean = false;
  public siteInspectionFlag: boolean = false;
  dataNotFoundMsg;
  errMsg;
  errFlag: boolean = false;
  constructor(private http: Http, private router: Router, private agentlocationservice: AgentlocationService,
    private searchTermservice: SearchTermservice) { }

  ngOnInit() {
    this.agentId = localStorage.getItem("AgentId");
    this.locationId = localStorage.getItem("LocationId");
    this.searchTermservice.detailsOfAgent(this.agentId).subscribe(res => {
      this.agentDetails = res;
    })

    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
    this.getLocationSummaryDetails();
  }

  getLocationSummaryDetails() {
    this.agentlocationservice.locationDetailsOfAgent(this.locationId).subscribe(res => {
      this.errFlag = false;
      if (res.Status == 200 && res.vendorLocationDetails.length > 0) {
        this.locationDetails = res.vendorLocationDetails[0];
        if (res.vendorLocationDetails[0].SecurityCamera == 'true') {
          this.siteInspectionFlag = true;
        }
        else {
          this.siteInspectionFlag = false;
        }
      }
      else if (res.Status == 200 && res.vendorLocationDetails.length == 0) {
        this.dataNotFoundMsg = "Data Not Found";
        this.errFlag = true;
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }

  checkboxchange(event: any) {
    if (event.target.checked) {
      this.fenceflag = true;
    }
    else {
      this.fenceflag = false;
    }
  }
  checkboxchange1(event: any) {
    if (event.target.checked) {
      this.siteInspectionFlag = true;
    }
    else {
      this.siteInspectionFlag = false;
    }
  }

  submit() {
    this.locationDetails.Fencing = this.fenceflag;
    this.locationDetails.SecurityCamera = this.siteInspectionFlag;
    this.agentlocationservice.saveAdditionalLocationData(this.locationDetails).subscribe(res => {
      if (res.Info == 'Updated Successfully') {
        this.submitSuccess = true;
        this.message = 'Additional Information Submitted';
      } else {
        this.message = 'Data is not submitted';
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/locationsummary/locationsummary.component.ts